import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle, Field, FieldLabel, Input } from '@clouway/ui'

import { useSession } from '@/features/auth'

export function Profile() {
  const { t } = useTranslation('feature')
  const { user } = useSession()

  return (
    <Card className="mx-auto w-full max-w-2xl">
      <CardHeader>
        <CardTitle>{t('profile.title')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <Field>
          <FieldLabel htmlFor="profile-name">{t('profile.name')}</FieldLabel>
          <Input id="profile-name" value={user?.displayName ?? ''} readOnly />
        </Field>
        <Field>
          <FieldLabel htmlFor="profile-email">{t('profile.email')}</FieldLabel>
          <Input id="profile-email" value={user?.email ?? ''} readOnly />
        </Field>
        {user?.customerName && (
          <Field>
            <FieldLabel htmlFor="profile-customer">{t('profile.customer')}</FieldLabel>
            <Input id="profile-customer" value={user.customerName} readOnly />
          </Field>
        )}
      </CardContent>
    </Card>
  )
}
